<footer class="bg-white text-900 px-4 py-8 md:px-6 lg:px-8 border-top-1 border-gray-200">
    <div class="mx-auto" style="max-width: 1800px;">
        <div class="grid">
            <div class="col-12 lg:col-4 mb-6 lg:mb-0">
                <img [src]="'assets/layout/images/branding/' + configService.config.brand + '/logo-colored-light-150.webp'"
                    [srcset]="'assets/layout/images/branding/' + configService.config.brand + '/logo-colored-light-150.webp 1x, assets/layout/images/branding/' + configService.config.brand + '/logo-colored-light-300.webp 2x'"
                    alt="ESZES Consultancy &amp; Services" width="142" height="40" class="mb-4">
                <p class="text-700 line-height-3 text-lg mb-6 pr-0 lg:pr-6">
                    ESZES Consultancy &amp; Services builds BMS, a modular business management platform, and the
                    software, integration and cloud services around it.
                </p>
                <ul class="list-none p-0 mt-0 mb-0 text-700 line-height-3">
                    <li class="flex align-items-start gap-2 mb-2"><i class="pi pi-map-marker text-primary mt-1"></i>
                        <span>Plot No. 36, Karuna, Pushpavihar,<br>Nadathara, Thrissur 680751, Kerala, India</span></li>
                    <li class="flex align-items-center gap-2 mb-2"><i class="pi pi-phone text-primary"></i>
                        <a href="tel:+919895013318" class="text-700 no-underline hover:text-primary">+91 98950 13318</a></li>
                    <li class="flex align-items-center gap-2"><i class="pi pi-envelope text-primary"></i>
                        <a href="mailto:info&#64;eszes.in" class="text-700 no-underline hover:text-primary">info&#64;eszes.in</a></li>
                </ul>
            </div>

            <div class="col-12 sm:col-6 md:col-3 lg:col-2 mb-4 lg:mb-0">
                <span class="text-900 block font-bold text-xl mb-4">Quick Links</span>
                <ul class="list-none p-0 m-0">
                    <li class="mb-3"><a routerLink="/"
                            class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Home</a>
                    </li>
                    <li class="mb-3"><a routerLink="/aboutus"
                            class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">About
                            Us</a></li>
                    <li class="mb-3"><a routerLink="/services"
                            class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Services</a>
                    </li>
                    <li class="mb-3"><a routerLink="/free-software"
                            class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Free software</a>
                    </li>
                    <li class="mb-3"><a routerLink="/snapcart"
                            class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Snapcart</a>
                    </li>
                    <li class="mb-3"><a routerLink="/contact"
                            class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Contact</a>
                    </li>
                </ul>
            </div>

            <div class="col-12 sm:col-6 md:col-3 lg:col-2 mb-4 lg:mb-0">
                <span class="text-900 block font-bold text-xl mb-4">Platform</span>
                <ul class="list-none p-0 m-0">
                    <li class="mb-3"><a routerLink="/services" class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">BMS modules</a></li>
                    <li class="mb-3"><a routerLink="/free-software" class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Free local edition</a></li>
                    <li class="mb-3"><a routerLink="/services" class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Custom development</a>
                    </li>
                    <li class="mb-3"><a routerLink="/contact" class="text-700 cursor-pointer hover:text-primary transition-colors no-underline">Hosted tenant enquiry</a></li>
                </ul>
            </div>

            <div class="col-12 md:col-6 lg:col-4">
                <span class="text-900 block font-bold text-xl mb-4">Talk to an engineer</span>
                <p class="text-700 mb-4 line-height-3">Tell us what you run today and we will show you the modules live.
                    Messages reach the people who write the software, and we reply by e-mail within one business day.</p>
                <button pButton label="Contact us" icon="pi pi-envelope" iconPos="right" routerLink="/contact"
                    class="p-button-primary p-button-rounded font-bold mb-5"></button>

                <ng-container *ngIf="newsletter.enabled">
                    <span class="text-900 block font-bold text-xl mb-3">Newsletter</span>
                    <p class="text-700 mb-3">Occasional e-mail about BMS releases and the free edition. No spam, unsubscribe any time.</p>
                    <form #nl="ngForm" (ngSubmit)="subscribe(nl)" novalidate>
                        <div class="p-inputgroup">
                            <input type="email" pInputText name="email" [(ngModel)]="email" #emailCtl="ngModel" required email
                                placeholder="Email Address" autocomplete="email" aria-label="Email address"
                                [disabled]="isSubmitting || subscribed" class="bg-gray-50 border-gray-200 text-900"
                                [class.ng-invalid]="emailCtl.invalid && emailCtl.touched">
                            <button type="submit" pButton [label]="subscribed ? 'Joined' : (isSubmitting ? 'Joining…' : 'Join')"
                                [disabled]="isSubmitting || subscribed" class="p-button-primary"></button>
                        </div>
                        <small *ngIf="emailCtl.invalid && emailCtl.touched && !subscribed" class="text-red-600 block mt-2">Please enter a valid e-mail address.</small>
                        <p *ngIf="subscribed" class="text-green-600 font-medium mt-3 mb-0"><i class="pi pi-check-circle mr-2"></i>Thanks, you are on the list.</p>
                        <p *ngIf="errorMessage" class="text-red-600 font-medium mt-3 mb-0"><i class="pi pi-times-circle mr-2"></i>{{ errorMessage }}</p>
                        <small class="text-600 block mt-2">We keep only your e-mail address. See the <a routerLink="/privacy" class="text-600 underline">privacy policy</a>.</small>
                    </form>
                </ng-container>
            </div>
        </div>

        <div
            class="border-top-1 border-gray-200 mt-8 pt-5 flex flex-column md:flex-row justify-content-between align-items-center gap-4">
            <span class="text-600">© 2026 ESZES Consultancy &amp; Services. All rights reserved.</span>
            <div class="flex gap-4">
                <a routerLink="/privacy" class="text-600 hover:text-900 cursor-pointer transition-colors no-underline">Privacy Policy</a>
                <a routerLink="/terms" class="text-600 hover:text-900 cursor-pointer transition-colors no-underline">Terms of Service</a>
            </div>
        </div>
    </div>
</footer>
